import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'promise-polyfill/src/polyfill';
import 'unfetch/polyfill/index.js';
import 'abortcontroller-polyfill';
import './styles/main.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { restoreFromLocalStorage } from 'localization/LocalizationData';
import React from 'react';
import ReactDom from 'react-dom';
import App from './App';

const rootElement = document.getElementById('root');

restoreFromLocalStorage();

ReactDom.render(
    <App />,
    rootElement);
